import { render, staticRenderFns } from "./svgIcon.vue?vue&type=template&id=363836b9&"
import script from "./svgIcon.vue?vue&type=script&lang=js&"
export * from "./svgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports